<template>
  <div class="mt15 spcial_area_wrapper">
    <div class="spcial_area_l">
      <router-link  to="/goodsNav/highQuality" class="spcial_area_l_top">
          <div class="spcial_area_l_top_l">
            <p class="l_p1">优选好铺</p>
            <p class="l_p2">铺好更放心</p>
          </div>
          <div class="spcial_area_l_top_r">
            <img src="../../images/youxuandaquan.png" class="l_img1" />
          </div>
      </router-link>
      <div class="spcial_area_l_btm">
        <router-link to="/goodsNav/twenty" class="spcial_area_l_btm_l">
          <div class="spcial_area_l_btm_l1">
            <p class="l_p3">二十元封顶</p>
            <p class="l_p2">价美包邮</p>
          </div>
          <div class="spcial_area_l_btm_l2">
            <img src="../../images/20yuanfengding.png" class="l_img2" />
          </div>
        </router-link>
        <router-link to="/goodsNav/seaNaughty" class="spcial_area_l_btm_r">
          <div class="spcial_area_l_btm_l3">
            <p class="l_p1">海淘精选</p>
            <p class="l_p2">良品好货也有券</p>
          </div>
          <div class="spcial_area_l_btm_l4">
            <img src="../../images/haitaojingxuan.png"  class="l_img3"/>
          </div>
        </router-link>
      </div>
    </div>
    <router-link to="/goodsNav/nine" class="spcial_area_r">
      <p class="r1_p1">9块9专区</p>
      <p class="r1_p2">不可错过的白菜价</p>
      <img src="../../images/99zhuanqu.png" class="r1_img" />
    </router-link>
  </div>
</template>
<script type = "text/ecamscript-6">
export default {
  name:"specialArea",
}
</script>
<style lang="stylus">
  .spcial_area_wrapper
    border-top:1px solid #e1e1e1
    border-bottom:1px solid #e1e1e1
    background:#fff
    height:400px
    display:flex
    .spcial_area_l
      flex:0 0 500px
      box-sizing:border-box
      border-right:1px solid #e1e1e1
      .l_p1
        font-size:32px
        color:#f34b4a
      .l_p2
        font-size:24px
        color:#777
      .l_p3
        font-size:32px
        color:#fc47ba
      .spcial_area_l_top
       height:200px
       border-bottom:1px solid #e1e1e1
       padding:30px 0 0 30px
       box-sizing:border-box
       display:flex
       .spcial_area_l_top_l
        flex:0 0 190px
        padding-top:15px
       .spcial_area_l_top_r
         flex:1
         .l_img1
            width:182px
            height:138px
      .spcial_area_l_btm
        height:200px
        display:flex
        .spcial_area_l_btm_l
          flex:1
          border-right:1px solid #e1e1e1
          box-sizing:border-box
          padding:25px 30px 0
          .spcial_area_l_btm_l2
            text-align:right
            padding-right:20px
            margin-top:-10px
            .l_img2
              width:88px
              height:91px
        .spcial_area_l_btm_r
          flex:1
          text-align:center
          padding-top:20px
          box-sizing:border-box
          .l_img3
            width:76px
            height:76px
            margin-top:10px
    .spcial_area_r
      flex:0 0 250px
      box-sizing:border-box
      height:400px
      padding-top:35px
      .r1_p1
        font-size:32px
        color:#000
        padding-left:20px
      .r1_p2
        font-size:24px
        color:#777
        padding-left:20px
      .r1_img
        width:179px
        height:171px
        display:block
        margin:50px auto 0

</style>



// WEBPACK FOOTER //
// src/components/goodsCoupon/specialArea.vue